import React, { useContext } from "react";
import { UserContext } from "wrapper/UserWrapper/context";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { PciConfig, PciSdkTypes } from "./utills";
import { NewCardPci } from "./NewCard";
import { SavedCardPci } from "./SavedCard";
import { OtpPci } from "./OTP";
import { get } from "../logics/src/utils/helpers";
import { doCheckOffers } from "../logics/src/utils/checkOffers";
import ExpressSavedCard from "./ExpressSavedCard";

const PCI = ({
  paymentContext,
  sdkType,
  doPayment,
  deviceType,
  setLoading,
  //this is only for savedcard
  lastInfoAvailable,
  // last four prop is only for new Card
  isAccordianOpened,
  toggleNewPaymentAccordian,
  endIcon,
  isDisabled,
  paymentScreen,
  accordian,
}: PciConfig) => {
  const { applicationData } = useContext(ApplicationContext);
  const { userData } = useContext(UserContext);
  const { CvvLessEligible, EightBin} = useContext(ExperimentAndSwitchContext);
  const paymentInfo = get(paymentContext, "paymentInfo");
  const flow = get(paymentContext, "flow");
  const cartInfo = get(paymentContext, "cartInfo");
  const cartRules = get(paymentContext, "offersData");
  const pciEnabled = get(paymentContext, "pciEnabled");
  const walletInfo = get(paymentContext, "walletInfo");
  const walletBalance = get(walletInfo, "balance");
  const grandTotal = get(cartInfo, "grandTotal");
  const orderAmount = get(paymentContext, "orderAmount");
  const recommendedPaymentDetails = get(paymentInfo, "recommendedPaymentDetails"); //this is for express checkout

  const getSavedCardList = (savedCards: any) => {
    if (savedCards?.length) {
      const savedCardsList = savedCards?.map((card: any) => {
        const cardData = {
          customerId: card?.customerId,
          expiryMonth: card?.expiryMonth,
          expiryYear: card?.expiryYear,
          logoUrl: card?.logoUrl,
          networkTypeIconUrl: card?.networkTypeIconUrl,
          last4: card?.last4,
          issuer: card?.issuer,
          maskedCardNumber: card?.maskedCardNumber,
          mode: card?.mode,
          name: card?.name,
          paymentGateway: card?.paymentGateway,
          token: card?.token,
          type: card?.type,
          offerKeys: card?.offerKeys,
          offerData: {},
          issuerBankIconUrl: card?.issuerBankIconUrl,
          tokenized: card?.tokenized,
          cvvLessEligible: CvvLessEligible?.switchEnabled && card?.cvvLessEligible,
          cvvLessMessage: CvvLessEligible?.switchEnabled ? card?.cvvLessMessage : "",
        };
        return cardData;
      });
      return savedCardsList
    }
    return [];
  }

  const pciPageLoadData: any = {
    paymentInfo: {
      token: paymentInfo?.token,
      tokenExpiry: paymentInfo?.tokenExpiry,
      sessionRefId: paymentInfo?.sessionRefId,
      savedCardDTOList: getSavedCardList(paymentInfo?.savedCardDTOList),
      paymentAmount: orderAmount,
      initialOrderAmount: grandTotal,
      razorPayCustId: paymentInfo?.razorPayCustId,
      lastInfoAvailable, //only for saved card
      isFullPaymentByWalletPossible: grandTotal <= walletBalance,
      cartOfferKey: cartInfo?.cartOfferKey,
      recommendedPaymentDetails,
      cardHashSalt: paymentInfo?.cardHashSalt || "",
      validBinlength: EightBin.switchEnabled ? 9 : 6,
    },
    applicationData: {
      platform: __PLATFORM__,
      deviceType: applicationData?.deviceType,
      isGuest: userData?.isGuest,
      flow,
      pciEnabled,
    },
    sdkType,
  };

  if (cartRules?.paymentRules?.length) {
    const savedCards = paymentInfo?.savedCardDTOList?.map((card: any) => {
      const cardData = {
        customerId: card?.customerId,
        expiryMonth: card?.expiryMonth,
        expiryYear: card?.expiryYear,
        issuer: card?.issuer,
        logoUrl: card?.logoUrl,
        networkTypeIconUrl: card?.networkTypeIconUrl,
        last4: card?.last4,
        maskedCardNumber: card?.maskedCardNumber,
        mode: card?.mode,
        name: card?.name,
        paymentGateway: card?.paymentGateway,
        token: card?.token,
        type: card?.type,
        offerKeys: card?.offerKeys,
        offerData: {},
        issuerBankIconUrl: card?.issuerBankIconUrl,
        tokenized: card?.tokenized,
        cvvLessEligible: CvvLessEligible?.switchEnabled && card?.cvvLessEligible,
        cvvLessMessage: CvvLessEligible?.switchEnabled ? card?.cvvLessMessage : "",
      };
      const offerKeys = card?.offerKeys;
      let offerData: any = {};
      const cardOfferData = {
        offerKey: "",
        amount: "",
        message: "",
        discountAmount: "",
      };
      let offers: any[] = [];
      const cardMode = card?.mode;
      if (offerKeys?.length) {
        offerKeys.forEach((offerKey: string) => {
          let offer = cartRules.paymentRules.filter((rule: any) => rule.ruleKey === offerKey);
          offers.push(offer);
          offers = offers.flat();
        });
        if (offers?.length > 1) {
          offers = offers.sort((a: any, b: any) => b?.priority - a?.priority);
        }

        if (offers?.length) {
          const keys = offers.map(offer => offer?.ruleKey);
          offerData = doCheckOffers(false, cardMode.toLowerCase(), cartRules, paymentInfo, keys);
          if (offerData?.hasOffers) {
            cardOfferData.message = offerData?.discountAmountMsg;
            cardOfferData.amount = offerData?.finalOrderAmount;
            cardOfferData.offerKey = offerData?.ruleKey;
            cardOfferData.discountAmount = offerData?.discountAmount;
            cardData.offerData = cardOfferData;
          }
        }
      }
      return cardData;
    });

    pciPageLoadData.paymentInfo.savedCardDTOList = savedCards;
    const offers = cartRules.paymentRules?.map((rule: PaymentOfferRule) => {
      return {
        ruleKey: rule?.ruleKey,
        paymentMethod: rule.paymentMethod,
      };
    });
    pciPageLoadData.paymentInfo.cartRules = offers;
  }

  if (sdkType === PciSdkTypes.NEW) {
    return (
      <NewCardPci
        pciPageLoadData={pciPageLoadData}
        doPayment={doPayment}
        deviceType={deviceType}
        setLoading={setLoading}
        isAccordianOpened={isAccordianOpened}
        toggleNewPaymentAccordian={toggleNewPaymentAccordian}
        endIcon={endIcon}
        isDisabled={isDisabled}
        paymentScreen={paymentScreen}
        accordian={accordian}
      />
    );
  } else if (sdkType === PciSdkTypes.SAVED) {
    return (
      <SavedCardPci
        pciPageLoadData={pciPageLoadData}
        doPayment={doPayment}
        deviceType={deviceType}
        setLoading={setLoading}
      />
    );
  } else if (sdkType === PciSdkTypes.OTP) {
    return <OtpPci pciPageLoadData={pciPageLoadData} setLoading={setLoading} />;
  } else if (sdkType === PciSdkTypes.EXPRESS_SAVED && recommendedPaymentDetails) {
    return (
      <ExpressSavedCard
        paymentContext = {paymentContext}
        pciPageLoadData={pciPageLoadData}
        doPayment={doPayment}
        setLoading={setLoading}
      />
    );
  }
  return null;
};

export default PCI;
